import React from 'react';
import Select from 'react-select';
import { Label } from 'reactstrap';
import { TRADER_KYC_STATUS } from 'utils/constants';

const subscriberOptions = [
  { value: 'All', label: 'All' },
  { value: 'subscribers', label: 'Subscribers' },
  { value: 'expireSubscribers', label: 'Expired Subscribers' },
  { value: 'deleted', label: 'Deleted' },
  { value: 'Inactive', label: 'Inactive (No Favourite)' },
  { value: 'Active', label: 'Active (Favourite)' },
  { value: 'Suspended', label: 'Suspended' },
  { value: 'NonRegistered', label: 'Non Registered' },
  { value: 'phoneOnlyUsers', label: 'N/A' },
  // { id: 'trialSubscriber', label: 'Trial Subscriber' },
];

const planExpiringOptions = [
  { value: 0, label: 0 },
  { value: 5, label: 5 },
  { value: 10, label: 10 },
];

const osTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'web', label: 'Web' },
  { value: 'android', label: 'Android' },
  { value: 'ios', label: 'iOS' },
];

const roleOptions = [
  { value: 'All', label: 'All' },
  { value: 'TRADER', label: 'Trader' },
  { value: 'BUYER', label: 'Buyer' },
  { value: 'SELLER', label: 'Seller' },
];

const VendorDropdownLists = ({
  selectedSubscriber,
  setSelectedSubscriber,
  selectedPlanExpiring,
  setSelectedPlanExpiring,
  selectedKycStatus,
  setSelectedKycStatus,
  selectedOsType,
  setSelectedOsType,
  selectedRole,
  setSelectedRole,
}) => {
  const handleSubscriberChange = (selectedOption) => {
    setSelectedSubscriber(selectedOption);
    if (
      selectedOption?.value === 'deleted' ||
      selectedOption?.value === 'Suspended' ||
      selectedOption?.value === 'Inactive' ||
      selectedOption?.value === 'Active' ||
      selectedOption?.value === 'phoneOnlyUsers'
    ) {
      setSelectedPlanExpiring(null);
      setSelectedKycStatus({ value: 'All', label: 'All' });
    }
    setSelectedPlanExpiring(null); // Reset plan expiring on subscriber change
  };

  const handlePlanExpiringChange = (val) => {
    if (val?.value === 0) setSelectedPlanExpiring(null);
    else setSelectedPlanExpiring(val);
  };
  return (
    <div className="filter-row-ui vendor-filter-row">
      {' '}
      <div className="form-group">
        <Label>User</Label>
        <Select
          name="Subscriber"
          options={subscriberOptions}
          placeholder="Subscriber"
          classNamePrefix="react-select"
          value={selectedSubscriber}
          // defaultMenuIsOpen
          onChange={handleSubscriberChange}
        />
      </div>
      <div className="form-group">
        <Label>KYC</Label>
        <Select
          name="kyc_status"
          options={[{ id: 'All', label: 'All' }, ...TRADER_KYC_STATUS]}
          placeholder="KYC Status"
          classNamePrefix="react-select"
          value={selectedKycStatus}
          onChange={setSelectedKycStatus}
          isDisabled={
            selectedSubscriber?.value === 'deleted' ||
            selectedSubscriber?.value === 'Suspended' ||
            selectedSubscriber?.value === 'Inactive' ||
            selectedSubscriber?.value === 'Active' ||
            selectedSubscriber?.value === 'phoneOnlyUsers'
          }
        />
      </div>
      <div className="form-group hours">
        <Label>Plan Expiring in</Label>
        <Select
          name="planExpiring"
          options={planExpiringOptions}
          placeholder="00 Days"
          classNamePrefix="react-select"
          value={selectedPlanExpiring}
          onChange={handlePlanExpiringChange}
          isDisabled={
            selectedSubscriber?.value !== 'subscribers' &&
            selectedSubscriber?.value !== 'expireSubscribers' &&
            selectedSubscriber?.value !== 'All'
          }
        />
      </div>
      <div className="form-group">
        <Label>OS Type</Label>
        <Select
          name="osType"
          options={osTypeOptions}
          placeholder="OS Type"
          classNamePrefix="react-select"
          value={selectedOsType}
          onChange={setSelectedOsType}
        />
      </div>
      <div className="form-group">
        <Label>Role</Label>
        <Select
          name="role"
          options={roleOptions}
          placeholder="Role"
          classNamePrefix="react-select"
          value={selectedRole}
          onChange={setSelectedRole}
        />
      </div>
    </div>
  );
};

export default VendorDropdownLists;
